import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {convertDateToString} from '../Functions/ConvertDateToString';
import withRouter from '../Functions/WithRouter';
import Axios from 'axios';

const profileIconBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/profile-icon-blue.png';
const opportunitiesIconBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/opportunities-icon-blue.png';
const deniedIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/denied-icon.png";
const closeIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/close-icon.png';
const loadingGIF = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/loading-gif.gif';

class RegisterUserToPosting extends Component {
    constructor(props) {
      super(props)

      this.state = {
        binaryOptions: [],

        assignees: [],
        suggestedAssignees: [],

        opportunities: [],
        suggestedOpportunities: [],
        eventRegistrationTypeOptions: ["RSVP","Attendee"]

      }

      this.retrieveData = this.retrieveData.bind(this)
      this.suggestedItemClicked = this.suggestedItemClicked.bind(this)
      this.addItem = this.addItem.bind(this)
      this.removeItem = this.removeItem.bind(this)
      this.deleteItem = this.deleteItem.bind(this)

      this.formChangeHandler = this.formChangeHandler.bind(this)
      this.searchAssignees = this.searchAssignees.bind(this)
      this.searchOpportunities = this.searchOpportunities.bind(this)
      this.addUserToPosting = this.addUserToPosting.bind(this)

      this.unloadRegistration = this.unloadRegistration.bind(this)
      this.pullOpportunity = this.pullOpportunity.bind(this)
      this.pullAssignee = this.pullAssignee.bind(this)
    }

    componentDidMount() {
      console.log('mountedRegisterUserToPosting')

      this.retrieveData()

    }

    componentDidUpdate(prevProps) {
      console.log('componentDidUpdate called in RegisterUserToPosting', this.props, prevProps)

      if (this.props.orgCode !== prevProps.orgCode) {
        this.retrieveData()
      }
    }

    retrieveData = () => {
      console.log('retrieveData called in RegisterUserToPosting', this.props)

      let emailId = localStorage.getItem('email');

      let registrationType = 'Registration'
      if (this.props.registrationType) {
        registrationType = this.props.registrationType
      }

      const selectedRegistration = this.props.selectedRegistration
      const selectedAssignee = this.props.selectedMember

      const orgCode = this.props.orgCode
      const orgName = this.props.orgName
      const orgContactFirstName = this.props.orgContactFirstName
      const orgContactLastName = this.props.orgContactLastName
      const orgContactEmail = this.props.orgContactEmail
      const screeningQuestions = this.props.screeningQuestions
      const selectedOpportunity = this.props.selectedOpportunity

      const attendees = this.props.attendees
      const rsvps = this.props.rsvps
      const applications = this.props.applications

      this.setState({ registrationType, screeningQuestions, selectedOpportunity,
        orgCode, orgName, orgContactFirstName, orgContactLastName, orgContactEmail,
        attendees, rsvps, applications, emailId,
        selectedRegistration, selectedAssignee
      })

      if (selectedRegistration) {
        this.unloadRegistration(selectedRegistration)
      }
    }

    unloadRegistration = async(selectedRegistration) => {
      console.log('unloadRegistration called')

      const _id = selectedRegistration._id

      const selectedOpportunity = await this.pullOpportunity(selectedRegistration.postingId)
      const selectedAssignee = await this.pullAssignee(selectedRegistration.email)

      // const selectedOpportunity = {
      //   _id: selectedRegistration.postingId,
      //   name: selectedRegistration.postingTitle,
      //   title: selectedRegistration.postingTitle,
      //   postType: selectedRegistration.postType,
      //   postingType: selectedRegistration.postType,
      //   employerName: selectedRegistration.postingEmployerName,
      //   location: selectedRegistration.postingLocation,
      //   departments: selectedRegistration.departments,
      //   targetRoles: selectedRegistration.targetRoles,
      //   selectedPrograms: selectedRegistration.selectedPrograms,
      //   selectedCohorts: selectedRegistration.selectedCohorts,
      // }
      //
      // const selectedAssignee = {
      //   firstName: selectedRegistration.firstName,
      //   lastName: selectedRegistration.lastName,
      //   email: selectedRegistration.email,
      //   username: selectedRegistration.username,
      //   firstName: selectedRegistration.firstName,
      //   firstName: selectedRegistration.firstName,
      // }

      let registrationType = selectedRegistration.registrationType

      this.setState({ _id, selectedOpportunity, registrationType, selectedAssignee })
    }

    pullOpportunity = async(_id) => {
      console.log('pullOpportunity called', _id)

      return await Axios.get('/api/postings/byid', { params: { _id } })
      .then(async(response) => {
        console.log('Posting query attempted', response.data);

          if (response.data.success) {
            console.log('posting query worked')

            return response.data.posting

          } else {
            console.log('posting query did not work', response.data.message)
          }

      }).catch((error) => {
          console.log('Posting query did not work for some reason', error);
      });
    }
    pullAssignee = async(email) => {
      console.log('pullAssignee called', email)

      return await Axios.get('/api/users/profile/details', { params: { email } })
      .then(async(response) => {
        console.log('Member query attempted', response.data);

          if (response.data.success) {
            console.log('member query worked')

            return response.data.user

          } else {
            console.log('member query did not work', response.data.message)
          }

      }).catch((error) => {
          console.log('Member query did not work for some reason', error);
      });
    }

    formChangeHandler = (event) => {
      console.log('formChangeHandler clicked', event.target.name, event.target.value)

      if (event.target.name === 'assigneeName') {
        const assigneeName = event.target.value
        this.setState({ assigneeName })
        this.searchAssignees(assigneeName)
      } else if (event.target.name === 'opportunityName') {
        const opportunityName = event.target.value
        this.setState({ opportunityName })
        this.searchOpportunities(opportunityName)
      } else {
        this.setState({ [event.target.name]: event.target.value })
      }
    }

    searchAssignees(assigneeName) {
      console.log('searchAssignees called', assigneeName, this.state.orgCode)

      this.setState({ isSaving: true, isLoadingAssignees: true })

      const orgCode = this.state.orgCode

      const self = this
      function officiallyFilter() {
        console.log('officiallyFilter called')

        Axios.get('/api/assignee/search', { params: { assigneeName, orgCode } })
        .then((response) => {
          console.log('Assignee search query attempted', response.data);

            if (response.data.success) {
              console.log('assignee search query worked')

              const suggestedAssignees = response.data.assignees
              self.setState({ suggestedAssignees, isSaving: false, isLoadingAssignees: false });

            } else {
              console.log('assignee search query did not work', response.data.message)
              const suggestedAssignees = []
              self.setState({ suggestedAssignees, isSaving: false, isLoadingAssignees: false })
            }

        }).catch((error) => {
            console.log('Assignee search query did not work for some reason', error);
        });
      }

      const delayFilter = () => {
        console.log('delayFilter called: ')
        clearTimeout(self.state.timerId)
        self.state.timerId = setTimeout(officiallyFilter, 1000)
      }

      delayFilter();
    }

    searchOpportunities(searchString) {
      console.log('searchOpportunities called', searchString, this.state.orgCode)

      this.setState({ isSaving: true, isLoadingOpportunities: true })

      const orgCode = this.state.orgCode
      const pullPartnerPosts = true
      let postTypes = ['Work','Program','Event']
      if (this.state.registrationType === 'RSVP or Attendee' || this.state.registrationType === 'RSVP' || this.state.registrationType === 'Attendee') {
        postTypes = ['Event']
      } else if (this.state.registrationType === 'Applicant') {
        postTypes = ['Program','Work']
      }

      const self = this
      function officiallyFilter() {
        console.log('officiallyFilter called')

        Axios.get('/api/postings/search', { params: { searchString, orgCode, pullPartnerPosts, postTypes } })
        .then((response) => {
          console.log('Opportunities search query attempted', response.data);

            if (response.data.success) {
              console.log('opportunities search query worked')

              const suggestedOpportunities = response.data.postings
              self.setState({ suggestedOpportunities, isSaving: false, isLoadingOpportunities: false });

            } else {
              console.log('opportunity search query did not work', response.data.message)
              const suggestedOpportunities = []
              self.setState({ suggestedOpportunities, isSaving: false, isLoadingOpportunities: false })
            }

        }).catch((error) => {
            console.log('Opportunities search query did not work for some reason', error);
            self.setState({ errorMessage: error.toString(), isSaving: false, isLoadingOpportunities: false })
        });
      }

      const delayFilter = () => {
        console.log('delayFilter called: ')
        clearTimeout(self.state.timerId)
        self.state.timerId = setTimeout(officiallyFilter, 1000)
      }

      delayFilter();

    }

    addItem(type) {
      console.log('addItem called', type)

      if (type === 'assignee') {
        if (this.state.assignee) {
          let assignee = this.state.assignee
          let selectedAssignee = this.state.assignee
          assignee = null
          let assigneeName = ''
          let suggestedAssignees = []
          this.setState({ selectedAssignee, assignee, assigneeName, suggestedAssignees })
        }
      } else if (type === 'opportunity') {
        if (this.state.opportunity) {
          let opportunity = this.state.opportunity
          let selectedOpportunity = this.state.opportunity
          opportunity = null
          let opportunityName = ''
          const suggestedOpportunities = []
          this.setState({ selectedOpportunity, opportunity, opportunityName, suggestedOpportunities })
        }
      }
    }

    removeItem(index, type) {
      console.log('removeItem called', index, type)

      if (type === 'assignee') {
        let assignees = this.state.assignees
        assignees.splice(index, 1)
        this.setState({ assignees })
      }
    }

    deleteItem() {
      console.log('deleteItem called', this.state._id)

      const _id = this.state._id

      let url = ''
      let engagementType = ''
      if (this.state.registrationType === 'Attendee') {
        url = '/api/attendee/'
        engagementType = 'attendee'
      } else if (this.state.registrationType === 'RSVP') {
        url = '/api/rsvp/'
        engagementType = 'rsvp'
      } else if (this.state.registrationType === 'Applicant') {
        url = '/api/applications/'
        engagementType = 'application'
      }
      console.log('but how: ', url, this.state.registrationType)
      Axios.delete(url + _id)
      .then((response) => {
        console.log('tried to delete', response.data)
        if (response.data.success) {

          if (this.props.passData) {
            this.props.passData(engagementType,{ _id },true)
          }

          if (this.props.closeModal) {
            this.props.closeModal()
          }

        } else {
          console.error('there was an error deleting the posting');
          this.setState({ errorMessage: response.data.message })
        }
      }).catch((error) => {
          console.log('The deleting did not work', error);
          this.setState({ errorMessage: error.toString() })
      });
    }

    suggestedItemClicked(type, value) {
      console.log('suggestedItemClicked called ', type, value)

      if (type === 'assignee') {
        const suggestedAssignees = []
        const assigneeName = value.firstName + ' ' + value.lastName

        this.setState({ suggestedAssignees, assignee: value, assigneeName })
      } else if (type === 'opportunity') {
        const suggestedOpportunities = []
        let opportunityName = value.name
        if (value.title) {
          opportunityName = value.title
        }

        let registrationType = this.state.registrationType
        if (value.postType === 'Work' || value.postType === 'Program') {
          registrationType = "Applicant"
        } else if (value.postType === 'Event') {
          registrationType = "RSVP"
        } else {
          // account for other cases
        }

        this.setState({ suggestedOpportunities, opportunity: value, opportunityName, registrationType })
      }
    }

    addUserToPosting() {
      console.log('addUserToPosting called')

      this.setState({ isSaving: true, serverPostSuccess: true, successMessage: null, errorMessage: null, disableSubmit: false })

      const self = this

      function actuallySave(saveObject) {
        console.log('actuallySave called', saveObject)

        let url = ''
        if (self.state.registrationType === 'Attendee') {
          url = '/api/attendee'
        } else if (self.state.registrationType === 'RSVP') {
          url = '/api/rsvp'
        } else if (self.state.registrationType === 'Applicant') {
          url = '/api/applications'
        }
        // console.log('a1', url)
        Axios.post(url, saveObject)
        .then((response) => {
          // console.log('a2', response.data)
          if (response.data.success) {
            console.log('Reserve worked', response.data);

            if (self.state.registrationType === 'Attendee') {
              if (window.location.pathname.includes('/members/') && self.props.passData) {
                self.props.passData('attendee',response.data.attendee)
              } else {
                let attendees = self.state.attendees
                if (attendees) {
                  attendees.push(response.data.attendee)
                  attendees.sort(function(a, b) {
                      let textA = ''
                      let textB = ''
                      if (a.lastName) {
                        textA = a.lastName.toUpperCase();
                      }
                      if (b.lastName) {
                        textB = b.lastName.toUpperCase();
                      }
                      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                  });
                } else {
                  attendees = [response.data.attendee]
                }

                if (self.props.passData) {
                  self.props.passData({ attendees })
                }
              }
            } else if (self.state.registrationType === 'RSVP') {
              if (window.location.pathname.includes('/members/') && self.props.passData) {
                self.props.passData('rsvp',response.data.rsvp)
              } else {
                let rsvps = self.state.rsvps
                if (rsvps) {
                  rsvps.push(response.data.rsvp)
                  rsvps.sort(function(a, b) {
                      let textA = ''
                      let textB = ''
                      if (a.lastName) {
                        textA = a.lastName.toUpperCase();
                      }
                      if (b.lastName) {
                        textB = b.lastName.toUpperCase();
                      }
                      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                  });
                } else {
                  rsvps = [response.data.rsvp]
                }

                if (self.props.passData) {
                  self.props.passData({ rsvps })
                }
              }

            } else if (self.state.registrationType === 'Applicant') {
              console.log('a1')
              if (window.location.pathname.includes('/members/') && self.props.passData) {
                console.log('a2')
                self.props.passData('application',response.data.application)
              } else {
                let applications = self.state.applications
                if (applications) {
                  applications.push(response.data.application)
                  applications.sort(function(a, b) {
                      let textA = ''
                      let textB = ''
                      if (a.lastName) {
                        textA = a.lastName.toUpperCase();
                      }
                      if (b.lastName) {
                        textB = b.lastName.toUpperCase();
                      }
                      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                  });
                } else {
                  applications = [response.data.application]
                }

                if (self.props.passData) {
                  self.props.passData({ applications })
                }
              }
            }
            console.log('a3')
            // const message = 'Member was added to posting!'
            self.setState({ isSaving: false, serverPostSuccess: true, successMessage: response.data.message, errorMessage: null, disableSubmit: false })

            if (self.props.closeModal) {
              self.props.closeModal()
            }

          } else {
            console.error('there was an error posting the wbl opportunity');
            const message = response.data.message
            self.setState({ isSaving: false, errorMessage: message, disableSubmit: false })
          }
        }).catch((error) => {
            console.log('The postings post did not work', error);
            self.setState({ isSaving: false, serverPostSuccess: false, errorMessage: error, disableSubmit: false })
        });
      }

      if (!this.state.selectedOpportunity) {
        return this.setState({ isSaving: false, serverPostSuccess: false, errorMessage: "Please add a posting", disableSubmit: false })
      } else if (!this.state.selectedAssignee) {
        return this.setState({ isSaving: false, serverPostSuccess: false, errorMessage: "Please add a member", disableSubmit: false })
      } else if (this.state.selectedAssignee) {

        const _id = this.state._id
        const postingId = this.state.selectedOpportunity._id
        let postingTitle = this.state.selectedOpportunity.name
        if (this.state.selectedOpportunity.title) {
          postingTitle = this.state.selectedOpportunity.title
        }
        const postType = this.state.selectedOpportunity.postType

        let firstName = this.state.selectedAssignee.firstName
        let lastName = this.state.selectedAssignee.lastName
        let email = this.state.selectedAssignee.email
        const jobTitle = this.state.selectedAssignee.jobTitle
        const employerName = this.state.selectedAssignee.employerName
        const schoolName = this.state.selectedAssignee.school
        const roleName = this.state.selectedAssignee.roleName
        const otherRoleName = this.state.selectedAssignee.otherRoleName
        let rsvpType = roleName
        let attendeeType = roleName

        const username = this.state.selectedAssignee.username
        const phoneNumber = this.state.selectedAssignee.phoneNumber
        const gradYear = this.state.selectedAssignee.gradYear
        const degree = this.state.selectedAssignee.degree
        const major = this.state.selectedAssignee.major
        const educationStatus = this.state.selectedAssignee.educationStatus
        const studentActivityInterests = []

        let rsvpResponses = []
        rsvpResponses.push({ question: 'First Name', answer: firstName })
        rsvpResponses.push({ question: 'Last Name', answer: lastName })
        rsvpResponses.push({ question: 'Email', answer: email })
        rsvpResponses.push({ question: 'Role Name', answer: roleName })
        rsvpResponses.push({ question: 'Other Role Name', answer: otherRoleName})

        // verify that all required fields are filled out
        if (this.state.screeningQuestions) {
          let questions = this.state.screeningQuestions

          for (let i = 1; i <= questions.length; i++) {
            rsvpResponses.push({
              question: questions[i - 1].name,
              questionType: questions[i - 1].questionType,
              answerChoices: questions[i - 1].answerChoices,
              shortname: questions[i - 1].shortname,
              mapToProfile: questions[i - 1].mapToProfile,
              // answer: this.state.responses[this.state.survey.questions.length + i - 1]
            })

            if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'dateOfBirth') || (questions[i - 1].name === 'Date of Birth' || questions[i - 1].name === 'Birthdate')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.dateOfBirth
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'gender')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.gender
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'race')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.race
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'races')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.races
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'selfDescribedRace')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.selfDescribedRace
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'address')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.address
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'zipcode')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.zipcode
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'numberOfMembers')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.numberOfMembers
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'householdIncome')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.householdIncome
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'workAuthorization')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.workAuthorization
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'adversityList')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.adversityList
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'educationStatus')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.educationStatus
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'phoneNumber')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.phoneNumber
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'alternativePhoneNumber')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.alternativePhoneNumber
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'alternativeEmail')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.alternativeEmail
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'city')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.city
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'referrerName')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.referrerName
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'referrerEmail')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.referrerEmail
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'referrerOrg')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.referrerOrg
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'education|name')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.school
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'education|degree')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.degree
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'education|endDate')) {

              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.gradYear
              if (this.state.selectedAssignee.gradDate && this.state.selectedAssignee.gradDate.split(" ") && this.state.selectedAssignee.gradDate.split(" ")[1]) {
                rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.gradDate.split(" ")[1]
              }
            } else if ((questions[i - 1].mapToProfile && questions[i - 1].shortname === 'education|major') || (questions[i - 1].name === 'Referrer Major')) {
              rsvpResponses[rsvpResponses.length - 1]['answer'] = this.state.selectedAssignee.major
            }
          }
        } else {
          rsvpResponses.push({ question: 'Education Status', answer: educationStatus })
          rsvpResponses.push({ question: 'School Name', answer: schoolName })
          rsvpResponses.push({ question: 'Grad Date', answer: this.state.selectedAssignee.gradDate})
          rsvpResponses.push({ question: 'Degree Type', answer: degree })
          rsvpResponses.push({ question: 'Major / Pathway', answer: major})
          rsvpResponses.push({ question: 'Activity Interests', answer: studentActivityInterests })
        }

        const location = this.state.selectedOpportunity.location

        const orgCode = this.state.orgCode
        const departments = this.state.selectedOpportunity.departments
        const targetRoles = this.state.selectedOpportunity.targetRoles
        const selectedPrograms = this.state.selectedOpportunity.selectedPrograms
        const selectedCohorts = this.state.selectedOpportunity.selectedCohorts

        const createdAt = new Date()
        const updatedAt = new Date()

        const orgName = this.state.orgName
        const orgContactFirstName = this.state.orgContactFirstName
        const orgContactLastName = this.state.orgContactLastName
        const orgContactEmail = this.state.orgContactEmail

        const doNotNotify = false

        let startDate = undefined // for events

        if (this.state.selectedOpportunity.startDate) {
          startDate = convertDateToString(new Date(this.state.selectedOpportunity.startDate),'datetime-2')
        }

        let endDate = undefined // for events
        if (this.state.selectedOpportunity.endDate) {
          endDate = convertDateToString(new Date(this.state.selectedOpportunity.endDate),'datetime-2')
        }

        const postingEmployerName = this.state.selectedOpportunity.employerName
        const postingLocation = this.state.selectedOpportunity.location
        const postingOrgCode = orgCode
        const postingOrgName = orgName
        const postingType = postType

        const alternativeEmail = this.state.selectedAssignee.alternativeEmail
        const alternativePhoneNumber = this.state.selectedAssignee.alternativePhoneNumber
        const resumeURL = this.state.selectedAssignee.resumeURL
        const coverLetterURL = this.state.selectedAssignee.coverLetterURL
        const linkedInURL = this.state.selectedAssignee.linkedInURL
        const customWebsiteURL = this.state.selectedAssignee.customWebsiteURL
        const education = this.state.selectedAssignee.education
        const certificates = this.state.selectedAssignee.certificates
        const zipcode = this.state.selectedAssignee.zipcode
        const dateOfBirth = this.state.selectedAssignee.dateOfBirth
        const address = this.state.selectedAssignee.address
        const race = this.state.selectedAssignee.race
        const races = this.state.selectedAssignee.races
        const selfDescribedRace = this.state.selectedAssignee.selfDescribedRace
        const gender = this.state.selectedAssignee.gender
        const veteran = this.state.selectedAssignee.veteran
        const workAuthorization = this.state.selectedAssignee.workAuthorization
        const numberOfMembers = this.state.selectedAssignee.numberOfMembers
        const householdIncome = this.state.selectedAssignee.householdIncome
        const fosterYouth = this.state.selectedAssignee.fosterYouth
        const homeless = this.state.selectedAssignee.homeless
        const incarcerated = this.state.selectedAssignee.incarcerated
        const adversityList = this.state.selectedAssignee.adversityList
        const identificationURL = this.state.selectedAssignee.identificationURL
        const letterOfRecommendationURL = this.state.selectedAssignee.letterOfRecommendationURL
        const transcriptURL = this.state.selectedAssignee.transcriptURL
        const preferredPronoun = this.state.selectedAssignee.preferredPronoun
        const language = this.state.selectedAssignee.language
        const city = this.state.selectedAssignee.city
        const state = this.state.selectedAssignee.state
        const country = this.state.selectedAssignee.country
        const direct = true
        const delegateAdminEmail = this.state.emailId

        const memberObject = {
          _id, postingId, postingTitle, postType, firstName, lastName, email, schoolName, jobTitle, employerName, orgCode,
          departments, targetRoles, selectedPrograms, selectedCohorts, roleName, otherRoleName, rsvpType, attendeeType,
          createdAt, updatedAt, orgName, orgContactFirstName, orgContactLastName, orgContactEmail,
          username, phoneNumber, gradYear, degree, major, educationStatus, studentActivityInterests,
          rsvpResponses, location, doNotNotify, startDate, endDate,

          postingEmployerName, postingLocation, postingOrgCode, postingOrgName, postingType, alternativeEmail, alternativePhoneNumber,
          resumeURL, coverLetterURL, linkedInURL, customWebsiteURL, education, certificates,
          zipcode, dateOfBirth, address, race, races, selfDescribedRace, gender, veteran, workAuthorization, numberOfMembers,
          householdIncome, fosterYouth, homeless, incarcerated, adversityList, identificationURL, letterOfRecommendationURL,
          transcriptURL, preferredPronoun, language, city, state, country, direct, delegateAdminEmail
        }

        actuallySave(memberObject)

      }
    }

    render() {

      return (
        <div>
          <div className="padding-40">
            <div>
              <div className="calc-column-offset-30">
                <p className="heading-text-2">{(this.state._id) ? "Delete " + this.state.registrationType : "Add " + this.state.registrationType + " to Posting"}</p>
              </div>
              <div className="fixed-column-30">
                <button className="background-button" onClick={() => this.props.closeModal()}>
                  <img src={closeIcon} alt="GC" className="image-auto-20 pin-right" />
                </button>
              </div>
              <div className="clear" />
            </div>

            <div className="spacer" /><div className="spacer" />

            {(this.state._id) ? (
              <div>
                <div className=" white-background table-container standard-border medium-shadow top-margin-20">
                  <table className={"default-table"}>
                    <thead>
                      <tr>
                        <th>Field Name</th>
                        <th>Field Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Posting</td>
                        <td>
                          <Link className="background-button" to={"/organizations/" + this.state.orgCode + "/postings/" + this.state.selectedOpportunity._id} target="_blank" rel="noopener noreferrer">
                            <p className="underline-text offset-underline">{(this.state.selectedOpportunity.title) ? this.state.selectedOpportunity.title : this.state.selectedOpportunity.name}{(this.state.selectedOpportunity.employerName) && " by " + this.state.selectedOpportunity.employerName} ({this.state.selectedOpportunity.postType}) posted on {convertDateToString(new Date(this.state.selectedOpportunity.createdAt),'date-2')}</p>
                          </Link>
                        </td>
                      </tr>
                      <tr>
                        <td>Registration Type</td>
                        <td>{this.state.registrationType}</td>
                      </tr>
                      <tr>
                        <td>User</td>
                        <td>{this.state.selectedAssignee.firstName} {this.state.selectedAssignee.lastName} ({this.state.selectedAssignee.email})</td>
                      </tr>
                      {(this.state.registrationType === 'Applicant') && (
                        <tr>
                          <td>Link to {this.state.registrationType}</td>
                          <td>
                            <Link className="background-button cta-color" to={"/organizations/" + this.state.orgCode + "/postings/" + this.state.selectedOpportunity._id + "/applications/" + this.state._id} state={{ selectedJob: this.state.selectedOpportunity, selectedApplication: this.props.selectedRegistration, applications: null, benchmark: null }}>
                              <p>Click Here</p>
                            </Link>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div>
                <div className="row-15">
                  <label className="profile-label">Selected Posting</label>

                  <div>
                    <div className="calc-column-offset-100 right-padding">
                      <input type="text" className="text-field" placeholder="Search for a posting..." name="opportunityName" value={this.state.opportunityName} onChange={this.formChangeHandler}></input>
                    </div>
                    <div className="fixed-column-100">
                      <button className="btn btn-squarish" onClick={() => this.addItem('opportunity')}>Add</button>
                    </div>
                    <div className="clear" />
                  </div>

                  <div className="clear" />
                  <div className="spacer" />

                  {(this.state.isLoadingOpportunities) ? (
                    <div className="flex-container flex-center full-space">
                      <div>
                        <div className="super-spacer" />

                        <img src={loadingGIF} alt="GC" className="image-auto-80 center-horizontally"/>
                        <div className="spacer" /><div className="spacer" /><div className="spacer" />
                        <p className="center-text cta-color bold-text">Searching opportunities...</p>

                      </div>
                    </div>
                  ) : (
                    <div>
                      {(this.state.suggestedOpportunities && this.state.suggestedOpportunities.length > 0) && (
                        <div>
                          <div className="spacer" />
                          {this.state.suggestedOpportunities.map(value =>
                            <div key={value._id} className="row-5">
                              <button className="background-button full-width left-text" onClick={() => this.suggestedItemClicked('opportunity',value)}>
                                <div>
                                  <div className="fixed-column-40 right-padding">
                                    <img src={opportunitiesIconBlue} alt="GC" className="image-auto-22" />
                                  </div>
                                  <div className="calc-column-offset-40">
                                    <p className="cta-color">{(value.title) ? value.title : value.name}{(value.employerName) && " by " + value.employerName} ({value.postType}) posted on {convertDateToString(new Date(value.createdAt),'date-2')}</p>
                                  </div>
                                </div>
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}

                  {(this.state.selectedOpportunity) && (
                    <div key={"selectedOpportunity"} className="float-left">
                      <div className="close-button-container-1">
                        <button className="background-button" onClick={() => this.setState({ selectedOpportunity: null })}>
                          <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                        </button>
                      </div>
                      <div className="calc-column-offset-8 row-5 right-padding">
                        <div className="tag-container-5">
                          <Link className="description-text-2" to={"/organizations/" + this.state.orgCode + "/postings/" + this.state.selectedOpportunity._id} target="_blank" rel="noopener noreferrer">{(this.state.selectedOpportunity.title) ? this.state.selectedOpportunity.title : this.state.selectedOpportunity.name}{(this.state.selectedOpportunity.employerName) && " by " + this.state.selectedOpportunity.employerName} ({this.state.selectedOpportunity.postType}) posted on {convertDateToString(new Date(this.state.selectedOpportunity.createdAt),'date-2')}</Link>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="clear" />
                </div>

                {(this.state.selectedOpportunity && this.state.selectedOpportunity.postType === 'Event') && (
                  <div className="row-15">
                    <div className="container-left">
                      <label className="profile-label">Registration Type <label className="error-color">*</label></label>
                      <select name="registrationType" value={this.state.registrationType} onChange={this.formChangeHandler} className="dropdown">
                        {this.state.eventRegistrationTypeOptions.map(value =>
                          <option key={value.key} value={value}>{value}</option>
                        )}
                      </select>
                    </div>
                    <div className="clear" />
                  </div>
                )}

                <div className="row-15">
                  <label className="profile-label">Selected Member</label>

                  <div>
                    <div className="calc-column-offset-100 right-padding">
                      <input type="text" className="text-field" placeholder="Search a name or email..." name="assigneeName" value={this.state.assigneeName} onChange={this.formChangeHandler}></input>
                    </div>
                    <div className="fixed-column-100">
                      <button className="btn btn-squarish" onClick={() => this.addItem('assignee')}>Add</button>
                    </div>
                    <div className="clear" />
                  </div>

                  <div className="clear" />
                  <div className="spacer" />

                  {(this.state.isLoadingAssignees) ? (
                    <div className="flex-container flex-center full-space">
                      <div>
                        <div className="super-spacer" />

                        <img src={loadingGIF} alt="GC" className="image-auto-80 center-horizontally"/>
                        <div className="spacer" /><div className="spacer" /><div className="spacer" />
                        <p className="center-text cta-color bold-text">Searching members...</p>

                      </div>
                    </div>
                  ) : (
                    <div>
                      {(this.state.suggestedAssignees && this.state.suggestedAssignees.length > 0) && (
                        <div>
                          <div className="spacer" />
                          {this.state.suggestedAssignees.map(value =>
                            <div key={value._id} className="row-5">
                              <button className="background-button" onClick={() => this.suggestedItemClicked('assignee',value)}>
                                <div>
                                  <div className="float-left right-padding">
                                    <img src={profileIconBlue} alt="Compass employer icon icon" className="image-auto-22" />
                                  </div>
                                  <div className="float-left">
                                    <p className="cta-color">{value.firstName} {value.lastName} ({value.email})</p>
                                  </div>
                                </div>
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}

                  {(this.state.selectedAssignee) && (
                    <div key={"selectedAssignee"} className="float-left">
                      <div className="close-button-container-1">
                        <button className="background-button" onClick={() => this.setState({ selectedAssignee: null })}>
                          <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                        </button>
                      </div>
                      <div className="float-left row-5 right-padding">
                        <div className="tag-container-5">
                          <p className="description-text-2"></p>
                          <Link className="description-text-2" to={"/organizations/" + this.state.orgCode + "/members/" + this.state.selectedAssignee.username} target="_blank" rel="noopener noreferrer">{this.state.selectedAssignee.firstName} {this.state.selectedAssignee.lastName} ({this.state.selectedAssignee.email})</Link>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="clear" />
                </div>

                <div className="spacer" />
              </div>
            )}

            {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="error-message">{this.state.errorMessage}</p>}
            {(this.state.successMessage && this.state.successMessage !== '') && <p className="success-message">{this.state.successMessage}</p>}

            <div className="spacer" /><div className="spacer" />

            {(this.state._id) ? (
              <div className="top-margin-20">
                {(this.state.confirmDelete) ? (
                  <div>
                    <p className="description-text-2 error-color">Are you sure you want to delete?</p>
                    <div className="top-margin">
                      <button className="btn btn-squarish error-background-color error-border right-margin-20" disabled={this.state.isSaving} onClick={() => this.deleteItem()}>Yes, Delete</button>
                      <button className="btn btn-squarish-white"  disabled={this.state.isSaving} onClick={() => this.setState({ confirmDelete: false })}>Cancel</button>
                    </div>
                  </div>
                ) : (
                  <button className="btn btn-quaternary"  disabled={this.state.isSaving} onClick={() => this.setState({ confirmDelete: true })}>Delete {this.state.registrationType}</button>
                )}
              </div>
            ) : (
              <button className="btn btn-primary"  disabled={this.state.isSaving} onClick={() => this.addUserToPosting()}>Add {this.state.registrationType}</button>
            )}
          </div>
        </div>
      )
    }
}

export default withRouter(RegisterUserToPosting);